import { connect } from 'formik'
import debounce from 'lodash.debounce'
import isEqual from 'lodash.isequal'
import React from 'react'

export const AutoSaveForm = connect(
  class FormikAutoSave extends React.Component<any> {
    save = debounce(() => {
      const { formik, onSave } = this.props
      if (!formik.isValid) {
        return
      }
      onSave(formik.values)
    }, 300)

    componentDidUpdate(prevProps: any) {
      const { formik } = this.props
      if (!isEqual(prevProps.formik.values, formik.values)) {
        this.save()
      }
    }

    render() {
      return null
    }
  },
)
